import { Card, Space, Table } from "antd";
import { Container } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";

const ProjectDatatable = (props: any) => {
  const navigate = useNavigate();

  const columns = [
    {
      dataIndex: "projectName",
      title: "projectName",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: any) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "running":
            color = "blue";
            break;
          case "in-progress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      key: "assignedTo",
      dataIndex: "assignedTo",
      title: "assignedTo",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "clientid",
      title: "clientid",
      key: "clientid",
      render: (_: any, value: any) => <span>{value?.Client?.companyName}</span>,
    },
    {
      dataIndex: "startDate",
      title: "startDate",
      render: (start_date: any) =>
        start_date ? moment(start_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "endDate",
      title: "endDate",
      render: (end_date: any) =>
        end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "projectType",
      title: "projectType",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/Project/projectview/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <Container>
      <br />
      <Card>
        <h3>Total {props?.meta?.total_count} Project</h3>
        <br />
        <Table
          columns={columns}
          dataSource={props?.dataSource}
          pagination={props?.pagination}
        />
      </Card>
    </Container>
  );
};

export default ProjectDatatable;
